import { SEARCHCUSTOMFIELD_SUCCESS, SEARCHCUSTOMFIELD_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const searchCustomFieldReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCHCUSTOMFIELD_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SEARCHCUSTOMFIELD_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default searchCustomFieldReducer;
